import React, { useState, useEffect } from 'react';
import { Radio, Button, Select, Checkbox } from 'antd';
import { useSelector } from 'react-redux';
import './accessTypePanel.css';
import { FormattedMessage } from 'react-intl';
import userAPI from '../../../../../API/user.service.api';
import tourPrevAPI from '../../../../../API/tour.prev.api';
import { accessType } from '../../../../../constants/tourAccessibilityTypes.constants';
import { ExtraTypePanel } from './ExtraTypePanel';
import { ExtraCheckBoxTypes } from './ExtraCheckBoxTypes';
import { PrivateTourIcon, PublicTourIcon } from '../../components/svg';
import SharingOverview from './SharingOverview';
import pageCache from '../../../../../API/cache.service';
import { URL } from '../../../../../constants/mapConstants';

function clearCache() {
  pageCache.destroy(URL.CLUB.ALL[0]);
  pageCache.destroy(URL.CLUB.MY[0]);
  pageCache.destroy(URL.BIKERBED.MY[0]);
  pageCache.destroy(URL.BIKERBED.ALL[0]);
  pageCache.destroy(URL.CLUB.MY[1]);
  pageCache.destroy(URL.BIKERBED.MY[1]);
}
/* eslint-disable */
const shouldComponentUpdate = (prevProps, nextProps) => {
  prevProps.tourType === nextProps.tourType &&
    prevProps.tourClubId === nextProps.tourClubId &&
    prevProps.listCheckedFriends &&
    nextProps.listCheckedFriends &&
    prevProps.listCheckedFriends.length === nextProps.listCheckedFriends.length;
};
/* eslint-enable */
export const AccessTypePanel = React.memo(
  ({
    tourType,
    listCheckedFriends,
    listCheckedClubs = [],
    tourClubId,
    updateTypes,
    currentUserId,
    language,
    setVisibility,
    rr_type,
    rr_id,
    publicAvailable,
    placeType,
  }) => {
    const { isLoggedIn, user } = useSelector((store) => store.authentication);
    const [bikerBedsData, setBikerBedsData] = useState([]);
    const [bikeClubsData, setBikeClubsData] = useState([]);
    const [friendsData, setFriendsData] = useState([]);
    const [bikeClubsChecked, setBikeClubList] = useState([]);
    const [bikerBedsChecked, setBikerBedList] = useState([]);
    const [rrTourTypes, setRRTourTypes] = useState({});
    const [topRadioValue, setTopRadioValue] = useState(
      tourType || accessType.DEFAULT_ONLY_FOR_ME_TYPE
    );
    const [checkedFriends, setCheckedFriends] = useState(
      listCheckedFriends || []
    );
    const [isDataLoaded, setLoadStatus] = useState(false);

    const [RRType, setRRType] = useState(rr_type || 'adventure');
    const [isRR, setIsRR] = useState(!!(rr_id || rr_type));

    useEffect(() => {
      const newTypes = {
        tourType: topRadioValue,
        listCheckedClubs: [...bikeClubsChecked, ...bikerBedsChecked].join(),
        listCheckedFriends: checkedFriends.join(),
        tourClubId,
        rr_type: isRR ? RRType : null,
      };

      updateTypes(newTypes);
    }, [
      topRadioValue,
      bikeClubsChecked,
      bikerBedsChecked,
      checkedFriends,
      isRR,
      RRType,
    ]);

    useEffect(() => {
      userAPI
        .getBikerBedsById(currentUserId)
        .then((res) => {
          const { code, entities } = res;
          if (code === 200) {
            setBikerBedsData([...entities]);
            const checkedClubs = entities
              .filter(({ id }) => listCheckedClubs.includes(id))
              .map(({ id }) => id);
            setBikerBedList(checkedClubs);
          } else {
            console.info(res);
          }
        })
        .catch((err) => console.log(err));

      userAPI
        .getClubsById(currentUserId)
        .then((res) => {
          const { code, clubs } = res;
          if (code === 200) {
            setBikeClubsData([...clubs]);
            const checkedClubs = clubs
              .filter(({ id }) => listCheckedClubs.includes(id))
              .map(({ id }) => id);
            setBikeClubList(checkedClubs);
          } else {
            console.info(res);
          }
        })
        .catch((err) => {
          //   setHistoryDataLoading(false);
          console.log(err);
        })
        .finally(() => setLoadStatus(true));

      userAPI
        .getFriendsById(currentUserId)
        .then((res) => {
          const { code, friends } = res;
          if (code === 200) {
            setFriendsData(friends);
          } else {
            console.info(res);
          }
        })
        .catch((err) => {
          //   setHistoryDataLoading(false);
          console.log(err);
        })
        .finally(() => setLoadStatus(true));

      tourPrevAPI
        .listRRTourTypes()
        .then((res) => {
          const { code, entities } = res;
          if (code === 200) {
            setRRTourTypes(entities);
            setRRType('adventure');
          } else {
            console.info(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, [currentUserId]);

    const clearExtraTypes = (newRadioValue) => {
      if (newRadioValue !== accessType.ALL_USERS_TYPE) {
        setBikeClubList([]);
        setBikerBedList([]);
      }
    };

    const clearCheckedList = (newRadioValue) => {
      if (newRadioValue !== accessType.SELECT_FRIENDS_TYPE) {
        setCheckedFriends([]);
      }
    };

    const topHandleChange = ({ target }) => {
      setTopRadioValue(target.value);
      clearExtraTypes();
      clearCheckedList(target.value);
    };

    const publicChange = (list, panelKey) => {
      setTopRadioValue(accessType.ALL_USERS_TYPE);
      if (panelKey === accessType.MY_BIKE_CLUB_TYPE) {
        setBikeClubList(list);
      } else if (panelKey === accessType.MY_BIKER_BED_TYPE) {
        setBikerBedList(list);
      }
      clearCache();
      clearCheckedList(accessType.ALL_USERS_TYPE);
    };

    const boxHandleChange = (list, panelKey) => {
      setTopRadioValue(+panelKey);
      setCheckedFriends(list);
      clearExtraTypes(+panelKey);
    };

    const getNameById = {
      bikeClub: (value) =>
        bikeClubsData.filter(({ id }) => id === value)[0]?.title,
      bikeClubs: (values) => values.map((value) => getNameById.bikeClub(value)),
      bikerBed: (value) =>
        bikerBedsData.filter(({ id }) => id === value)[0]?.title,
      bikerBeds: (values) => values.map((value) => getNameById.bikerBed(value)),
      friend: (value) => friendsData.filter(({ id }) => id === value)[0]?.name,
      friends: (values) => values.map((value) => getNameById.friend(value)),
    };

    const handleSelectRRTypeChange = (value) => setRRType(value);
    const handleChangeIsRR = (e) => setIsRR(e.target.checked);

    const isRrADMIN = () =>
      isLoggedIn && user && process.env.RR_ADMIN.includes(user.id);

    const isNafADMIN = () =>
      isLoggedIn && user && process.env.NAF_ADMIN.includes(user.id);

    const isMargueritrutenAdmin = () =>
      isLoggedIn && user && process.env.TOURSTART_ADMIN.includes(user.id);

    const roadRunnerSharePanel = () => {
      return isRrADMIN() ? (
        <Checkbox
          onChange={handleChangeIsRR}
          checked={isRR}
          className="access_tour_type_rr_checkbox"
        >
          <span>RR Tour</span>
          <Select
            style={{
              width: 150,
              position: 'absolute',
              right: 7,
              top: 7,
            }}
            defaultValue={RRType}
            value={RRType}
            onChange={handleSelectRRTypeChange}
            disabled={!isRR}
          >
            {Object.entries(rrTourTypes).map(([key, type]) => {
              return (
                <Select.Option value={key} key={type}>
                  {type}
                </Select.Option>
              );
            })}
          </Select>
        </Checkbox>
      ) : // </Panel>
      null;
    };

    const getPublicHeader = () => {
      const styleDiv = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '5px',
        with: '100%',
      };
      return (
        <div style={styleDiv}>
          <Button
            type="primary"
            // size="large"
            onClick={() => setVisibility(false)}
            className="saveBtn"
          >
            <span>
              <FormattedMessage id="Save" defaultMessage="Save" />
            </span>
          </Button>
        </div>
      );
    };

    return (
      <>
        <div className="access-tour-type-common">
          <SharingOverview
            accessType={tourType}
            friends={getNameById.friends(checkedFriends)}
            bikeClubs={getNameById.bikeClubs(bikeClubsChecked)}
            bikerBeds={getNameById.bikerBeds(bikerBedsChecked)}
          />

          <div className="privacy-settings">
            <section className="private-settings">
              <Radio.Group
                onChange={topHandleChange}
                name="tourAccess"
                value={topRadioValue}
                style={{ position: 'relative', width: '100%' }}
              >
                <p className="access-type">
                  <PrivateTourIcon />
                  <span>
                    <FormattedMessage id="Private" defaultMessage="Private" />
                  </span>
                </p>
                <Radio
                  value={accessType.DEFAULT_ONLY_FOR_ME_TYPE}
                  className="top-radio-list radio-style"
                >
                  {language['For me only']}
                </Radio>
                <Radio
                  value={accessType.MY_FRIENDS_AND_ME_TYPE}
                  className="top-radio-list radio-style"
                >
                  {language['My friends and me']}
                </Radio>
                <div
                  style={{ position: 'relative' }}
                  className="select-friend-settings"
                >
                  <Radio
                    value={accessType.SELECT_FRIENDS_TYPE}
                    className="top-radio-list radio-style"
                  >
                    {language['Select friends']}
                  </Radio>
                  <ExtraCheckBoxTypes
                    data={friendsData}
                    panelKey={accessType.SELECT_FRIENDS_TYPE}
                    header={language['Select friends']}
                    handleChange={boxHandleChange}
                    checkedList={checkedFriends}
                    emptyListText={
                      language[
                        'Add some friends so you can share the tour with them'
                      ]
                    }
                    isDataLoaded={isDataLoaded}
                  />
                </div>
              </Radio.Group>
            </section>
            <section>
              <Radio.Group
                onChange={topHandleChange}
                name="tourAccess"
                value={topRadioValue}
                style={{ position: 'relative', width: '100%' }}
              >
                <p className="access-type">
                  <PublicTourIcon />
                  <span>
                    <FormattedMessage id="Public" defaultMessage="Public" />
                  </span>
                </p>
                {tourType === accessType.ALL_USERS_TYPE && !publicAvailable ? (
                  <div className="tour-access-warnings">
                    {language['Public tour should have at least one picture']}
                  </div>
                ) : null}
                <Radio
                  value={accessType.ALL_USERS_TYPE}
                  className="top-radio-list radio-style"
                >
                  {language['All Tourstart users']}
                </Radio>
                {isNafADMIN() && !placeType && (
                  <Radio
                    value={accessType.NAF_TOUR}
                    className="top-radio-list radio-style"
                  >
                    {language['NAF Tour']}
                  </Radio>
                )}
                {isMargueritrutenAdmin() && !placeType && (
                  <Radio
                    value={accessType.MARGUERITRUTEN_TOUR}
                    className="top-radio-list radio-style"
                  >
                    {language.Margueritruten}
                  </Radio>
                )}
                <ExtraTypePanel
                  data={bikeClubsData}
                  key={accessType.MY_BIKE_CLUB_TYPE}
                  type={accessType.MY_BIKE_CLUB_TYPE}
                  header={language['My Bike Club']}
                  emptyListText={language['No BikeClub']}
                  handleChange={publicChange}
                  checkedClubs={bikeClubsChecked}
                  selected={topRadioValue === accessType.MY_BIKE_CLUB_TYPE}
                  isDataLoaded={isDataLoaded}
                />
                <ExtraTypePanel
                  data={bikerBedsData}
                  key={accessType.MY_BIKER_BED_TYPE}
                  type={accessType.MY_BIKER_BED_TYPE}
                  header={language['My BikerBed']}
                  emptyListText={language['No BikerBed']}
                  handleChange={publicChange}
                  checkedClubs={bikerBedsChecked}
                  selected={topRadioValue === accessType.MY_BIKER_BED_TYPE}
                  isDataLoaded={isDataLoaded}
                />
              </Radio.Group>
            </section>
            <section>{!placeType && roadRunnerSharePanel()}</section>
          </div>

          {getPublicHeader()}
        </div>
      </>
    );
  },
  shouldComponentUpdate
);
